import React, { Fragment, useEffect, useState } from 'react'
import Humberg from '../../../elements/Humberg'
import { Link, useSearchParams } from 'react-router-dom'
import Img1 from "../../images/user-profile.png"
import Img2 from "../../images/realtor.png"
import Img4 from "../../images/checkout.png"
import Img5 from "../../images/user-products.png"
import Img6 from "../../images/message.png"
import Profile from './Profile.jsx'
import Chat from './Chat.jsx'
import { useDispatch, useSelector } from 'react-redux'
import { allAdminsAction, changeAdminAction, clearErrors, userDetailsAction } from '../../../redux/actions/userActions.js'
import Loader from '../../loader/loader.jsx'
import { toast } from 'react-toastify'
const SingleUser = () => {




  const dispatch = useDispatch()



  const { loading, error, user } = useSelector((state) => state.userDetails)
  const { user: loggedInUser } = useSelector((state) => state.verifyEmailStore)
  const { loading: userLoading, admins } = useSelector((state) => state.getUsers)


  const [index, setindex] = useState(1)
  const [showPopup, setshowPopup] = useState(false)
  const [adminID, setAdminID] = useState("")

  const [searchParams] = useSearchParams();
  const id = searchParams.get("user_id");



  useEffect(() => {
    const Headerlinkks = document.querySelectorAll(".headerLinks");
    const subLinks = document.querySelectorAll(".subLinks");
    const element = document.getElementById("dashboard")


    Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
    subLinks.forEach(el => el.classList.remove("activeSubLink"));
    element?.classList.add("activeHeaderLink");

    document.title = `${user?.name} - Admin Panel`;

  }, [user]);



  useEffect(() => {

    if (loggedInUser?.role === "SUPER_ADMIN") {
      let query = {}
      query.status = "ACTIVE"
      query.perPage = 100

      dispatch(allAdminsAction(query))
    }

  }, [loggedInUser, dispatch])



  useEffect(() => {
    // Only fetch if:
    // 1. We have an ID
    // 2. We are not already loading
    // 3. We don't have a current error (to prevent looping on "User not found")
    // 4. The user is not loaded OR the loaded user is different from the ID in URL
    if (id && !loading && !error && (!user || String(user.id) !== String(id))) {
      dispatch(userDetailsAction(id))
    }
  }, [dispatch, id, user?.id, loading, error,user])



  useEffect(() => {
    if (error) {
      dispatch(clearErrors())
    }
  }, [error, dispatch])



  useEffect(() => {


    if (user?.admin_id) {
      setAdminID(user?.admin_id)
    }
  }, [user?.admin_id])



  const handleAdminChange = () => {

    if (!adminID) {
      toast.error("Please select admin")
      return;
    }
    if (Number(adminID) === user?.admin_id) {
      toast.error("Please select different admin")
      return;
    }


    dispatch(changeAdminAction({ user_id: id, admin_id: adminID }))
  }




  return (

    <Fragment>
      {(loading || userLoading) && <Loader />}
      <Humberg header="Dashboard" headerLink="/" children={"User Details"} innerChildren={user?.name || user} />
      <section className='p-[1.5vmax] pt-[1vmax]' >
        <div className="bg-white p-[2vmax] rounded-xl shadow-1 flex justify-between relative flex-wrap">
          <div className="w-full lg:w-[20%] lg:sticky top-[5vmax] h-fit">
            <button className={`w-full flex items-center justify-start gap-[1vmax]  my-[0.4vmax] hover:bg-gray-100
               p-[0.6vmax_1vmax] rounded-lg text-left ${index === 1 ? "bg-gray-100" : ""}`}
              onClick={() => setindex(1)}
            >
              <img src={Img1} alt="" className="w-[2.5vmax] lg:w-[1.5vmax]" />
              <span className="text-gray-600 text-[1.5vmax] lg:text-[1vmax] font-1  font-[500]" >Profile</span>
            </button>

            {user?.role === "ADMIN" &&
              <>
                <Link to={`/dashboard/pmm-list?admin_id=${user?.id}`} className={`w-full flex items-center justify-start gap-[1vmax]  my-[0.4vmax] hover:bg-gray-100
               p-[0.6vmax_1vmax] rounded-lg text-left `}>
                  <img src={Img2} alt="" className="w-[2.5vmax] lg:w-[1.5vmax]" />
                  <span className="text-gray-600 text-[1.5vmax] lg:text-[1vmax] font-1  font-[500]" >PMMs</span>
                </Link>

              </>

            }
            {user?.role === "PMM" &&

              <Link to={`/products/all-products?seller_id=${user?.id}`} className={`w-full flex items-center justify-start gap-[1vmax]  my-[0.4vmax] hover:bg-gray-100
               p-[0.6vmax_1vmax] rounded-lg text-left ${index === 5 ? "bg-gray-100" : ""}`}
                onClick={() => setindex(5)}
              >
                <img src={Img5} alt="" className="w-[2.5vmax] lg:w-[1.5vmax]" />
                <span className="text-gray-600 text-[1.5vmax] lg:text-[1vmax] font-1  font-[500]" >Products</span>
              </Link>
            }
            {user?.role !== "ADMIN" &&
              <Link to={`/orders/all-orders?${user?.role === "PMM" ? `seller_id=${user?.id}` : `pm_id=${user?.id}`}`} className={`w-full flex items-center justify-start gap-[1vmax]  my-[0.4vmax] hover:bg-gray-100
               p-[0.6vmax_1vmax] rounded-lg text-left ${index === 4 ? "bg-gray-100" : ""}`}
                onClick={() => setindex(4)}
              >
                <img src={Img4} alt="" className="w-[2.5vmax] lg:w-[1.5vmax]" />
                <span className="text-gray-600 text-[1.5vmax] lg:text-[1vmax] font-1  font-[500]" >Orders</span>
              </Link>
            }

            <Link to={`/messenger?new_chat=true&user_id=${user?.id}`} className={`w-full flex items-center justify-start gap-[1vmax]  my-[0.4vmax] hover:bg-gray-100
               p-[0.6vmax_1vmax] rounded-lg text-left ${index === 6 ? "bg-gray-100" : ""}`}
              onClick={() => setindex(6)}
            >
              <img src={Img6} alt="" className="w-[2.5vmax] lg:w-[1.5vmax]" />
              <span className="text-gray-600 text-[1.5vmax] lg:text-[1vmax] font-1  font-[500]" >Chat</span>
            </Link>
          </div>
          <div className="w-full lg:w-[78%]">
            {
              index === 1 && <Profile user={user} setshowPopup={setshowPopup} />
            }

            {
              index === 6 && <Chat />
            }
          </div>
        </div>
      </section>
      {showPopup &&
        <section className="flex-center w-[100vw] h-[100vh] fixed top-0 left-0 bg-black bg-opacity-50 z-[9999]">
          <button className="fixed top-[2vmax] right-[2vmax] text-white text-[2.5vmax]"
            onClick={() => setshowPopup(false)}
          >
            <i className="fa-solid fa-xmark z-[99999]"></i>
          </button>
          <div className="bg-white w-[80%] lg:w-[30%] p-[2vmax] rounded-xl">
            <h2 className="text-[1.5vmax] font-[600] mb-[1vmax]">Change Admin</h2>
            <select className="w-[100%] border-[0.15vmax] border-slate-300 rounded-md p-[0.6vmax_1vmax] mt-[0.3vmax] outline-none font-[400] text-[1.5vmax] lg:text-[1.1vmax] focus:border-[var(--color-2)] transition-all duration-200" placeholder="Enter User Email"
              value={adminID} onChange={(e) => setAdminID(e.target.value)}
            >
              <option value="" >-- Select Admin</option>
              {
                admins?.length > 0 ?
                  admins?.map((admin) => (
                    <option value={admin?.id} >{admin?.name}</option>
                  ))
                  :
                  <option value="" >No Admin Found</option>
              }
            </select>
            <button className="w-[100%] bg-[image:var(--gradient-2)] text-white text-[1.2vmax] font-[500] p-[0.6vmax_1vmax] rounded-md mt-[1vmax] hover:bg-[var(--color-1)] transition-all duration-200"
              onClick={handleAdminChange}
            >Change</button>
          </div>
        </section>
      }


    </Fragment>
  )
}

export default SingleUser